var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30761 7.00053H12.4444C12.7513 7.00053 13 7.22439 13 7.50053C13 7.77667 12.7513 8.00053 12.4444 8.00053H4.30761L8.40381 12.0967C8.59907 12.292 8.59907 12.6086 8.40381 12.8038C8.20854 12.9991 7.89196 12.9991 7.6967 12.8038L3.45406 8.56119C3.19586 8.30299 3.05147 7.97408 3.02088 7.6368C3.00728 7.59348 3 7.54777 3 7.50053C3 7.45329 3.00728 7.40758 3.02088 7.36426C3.05147 7.02697 3.19586 6.69807 3.45406 6.43987L7.6967 2.19723C7.89196 2.00197 8.20854 2.00197 8.40381 2.19723C8.59907 2.39249 8.59907 2.70907 8.40381 2.90433L4.30761 7.00053Z",
    fill: "#343741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLeftArrow);
export default __webpack_public_path__ + "static/media/CalendarLeftArrow.99cf824364683d50435a2e3bb418ebc3.svg";
export { ForwardRef as ReactComponent };